export class UserModel {
  public id!: string;
  public companyId!: number;
  public zendeskUserId!: number;
  public fullName!: string;
  public email!: string;
  public roleId!: number;
  public departmentId!: number;
  public isTwilioSetup!: boolean;
  public isZing!: boolean;
  public isXeroLinked!: boolean;
  public hasZingRespond!: boolean;
}
